import { Component } from "@angular/core";
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'unit-three-lesson-one-guide',
    templateUrl: './_guide.component.html',
    styleUrls: ['../../_shared/lesson-guides/lesson-guide.component.css']
})
export class UnitThreeLessonOneGuideComponent {

    pageTitle: string = "Lesson Guide | Unit 3, Lesson 1 | T-Folio";
    title: string = "Lesson Guide";
    subtitle: string = "Lesson 1: Introduction to Work-Based Learning";

    public constructor(private titleService: Title) {
        this.titleService.setTitle(this.pageTitle);
    }
}
